import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Image,
  List,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

function NpwpImagePreviewModal({ npwp, open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>NPWP Details</ModalHeader>
      <ModalContent>
        <List>
          <List.Item>
            <strong>NPWP Number:</strong> {npwp.number}
          </List.Item>
          <List.Item>
            <strong>NPWP Name:</strong> {npwp.name}
          </List.Item>
        </List>
        {!!npwp.image && <Image src={npwp.image} size="large" />}
      </ModalContent>
      <ModalActions>
        <Button primary onClick={onClose}>
          Close
        </Button>
      </ModalActions>
    </Modal>
  );
}

NpwpImagePreviewModal.propTypes = {
  npwp: PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NpwpImagePreviewModal;
